import { useLetterBoxFilter } from '../../../../Features/letterBox/context/FilterContext';
import React, { useEffect, useId, useState } from 'react';
import { fieldEmail } from '../../../../Features/letterBox/api/types';
import { flattenEmails } from '../../../../Features/letterBox/api/emailTree';

type Props = { email: fieldEmail; renderRow: (email: fieldEmail, toggle?: React.ReactNode) => React.ReactNode };

export default function EmailThread({ email, renderRow }: Props) {
    const { filters } = useLetterBoxFilter();
    const [expanded, setExpanded] = useState(false);
    const panelId = useId();
    const replies = flattenEmails(email.children ?? []);
    const hasUnreadReplies = replies.some(reply => reply.is_read === 0);
    useEffect(() => {
        if (filters.new === 1 && hasUnreadReplies) setExpanded(true);
    }, [filters.new, hasUnreadReplies]);
    const toggle = replies.length > 0 ? (
        <button
            type="button"
            className="btn btn-sm btn-light d-inline-flex align-items-center gap-2 text-nowrap"
            aria-expanded={expanded}
            aria-controls={panelId}
            aria-label={`${expanded ? 'Nascondi' : 'Mostra'} ${replies.length} risposte`}
            onClick={event => { event.stopPropagation(); setExpanded(current => !current); }}
        >
            <i className={`fa-solid fa-chevron-${expanded ? 'down' : 'right'}`} aria-hidden="true" />
            {replies.length}
        </button>
    ) : undefined;

    return (
        <React.Fragment>
            {renderRow(email, toggle)}
            {replies.length > 0 && (
                <li id={panelId} className="email-thread" style={{ display: expanded ? 'block' : 'none', padding: '0 16px 12px' }}>
                    {expanded && (
                        <ul className="simple-list" style={{ borderLeft: '2px solid var(--light-gray)', paddingLeft: 12 }}>
                            {replies.map(reply => <React.Fragment key={reply.id}>{renderRow(reply)}</React.Fragment>)}
                        </ul>
                    )}
                </li>
            )}
        </React.Fragment>
    );
}